import React from "react";
import { motion } from "framer-motion";
import { X, ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import MarkdownRenderer from "../Components/MarkdownRenderer";

export default function TermsOfService({ onClose }) {
    const { t, language } = useLanguage();

    const content = {
        it: {
            title: "Termini e Condizioni di Servizio",
            lastUpdated: "Ultimo aggiornamento: 16 Febbraio 2026",
            sections: [
                {
                    title: "1. Informazioni Generali",
                    content: `I presenti Termini e Condizioni di Servizio regolano l'utilizzo del sito web www.lg-mi.it (di seguito "Sito") e i servizi offerti da ELLEGI S.r.l. (di seguito "ELLEGI" o "Società").

**ELLEGI S.r.l.**
Sede legale: Viale Vittorio Veneto, 6 - 20124 Milano (MI), Italia
P.IVA: 08437620159
Email: comm@lg-mi.it
Tel: +39 02 2895741

L'utilizzo del Sito implica l'accettazione integrale e incondizionata dei presenti Termini e Condizioni.`
                },
                {
                    title: "2. Accettazione dei Termini",
                    content: `Accedendo e utilizzando questo Sito, l'utente dichiara di:

- Aver letto, compreso e accettato integralmente i presenti Termini e Condizioni
- Avere la capacità giuridica per accettare questi termini
- Essere maggiorenne secondo la legislazione italiana (18 anni compiuti)
- Utilizzare il Sito in conformità con le leggi applicabili

Se non accetti questi termini, ti preghiamo di non utilizzare il Sito.`
                },
                {
                    title: "3. Servizi Offerti",
                    content: `ELLEGI è specializzata nella fornitura di soluzioni di illuminazione professionale per i seguenti settori:

- **Uffici:** Illuminazione per ambienti di lavoro
- **Retail:** Soluzioni per negozi e spazi commerciali
- **Hospitality:** Illuminazione per hotel, ristoranti e strutture ricettive
- **Industria:** Soluzioni per ambienti industriali e produttivi
- **Consulenza:** Progettazione illuminotecnica e consulenza specialistica

I servizi possono includere:
- Consulenza e progettazione
- Fornitura di apparecchi illuminanti
- Installazione e manutenzione
- Assistenza tecnica post-vendita

Le specifiche condizioni commerciali saranno definite in appositi contratti o preventivi.`
                },
                {
                    title: "4. Proprietà Intellettuale",
                    content: `Tutti i contenuti presenti sul Sito, inclusi ma non limitati a:

- Testi, immagini, fotografie, video
- Loghi, marchi, segni distintivi
- Grafica, layout, design
- Software, codice sorgente
- Documenti tecnici, cataloghi, schede prodotto

sono di proprietà esclusiva di ELLEGI S.r.l. o dei rispettivi titolari e sono protetti dalle leggi italiane e internazionali sul diritto d'autore e sulla proprietà industriale.

**È vietato:**
- Riprodurre, copiare, modificare o distribuire i contenuti senza autorizzazione scritta
- Utilizzare i contenuti per scopi commerciali non autorizzati
- Rimuovere o alterare indicazioni di copyright, marchi o altri diritti
- Effettuare reverse engineering o decompilazione del software

È consentito:
- Visualizzare e scaricare i contenuti per uso personale e non commerciale
- Condividere link al Sito
- Citare brevi estratti con opportuna attribuzione`
                },
                {
                    title: "5. Obblighi dell'Utente",
                    content: `L'utente si impegna a:

**Utilizzo Lecito**
- Utilizzare il Sito in modo conforme alla legge e ai buoni costumi
- Non violare diritti di terzi o della Società
- Non diffondere contenuti illegali, diffamatori, osceni o minacciosi

**Sicurezza**
- Non tentare di accedere ad aree riservate del Sito
- Non effettuare attacchi informatici, hacking o altre attività dannose
- Non inviare virus, malware o codice dannoso
- Non sovraccaricare i server o interferire con il funzionamento del Sito

**Comunicazioni**
- Fornire informazioni veritiere e accurate nei form di contatto
- Non utilizzare il Sito per spam o comunicazioni non richieste
- Rispettare la privacy di terzi

La violazione di questi obblighi può comportare la sospensione dell'accesso al Sito e azioni legali.`
                },
                {
                    title: "6. Limitazione di Responsabilità",
                    content: `Nei limiti consentiti dalla legge, ELLEGI:

**Disponibilità del Sito**
- Non garantisce che il Sito sia sempre disponibile, privo di errori o interruzioni
- Si riserva il diritto di modificare, sospendere o interrompere il Sito in qualsiasi momento
- Non è responsabile per disservizi causati da fattori esterni (connessioni internet, forza maggiore)

**Contenuti**
- Si impegna a fornire informazioni accurate, ma non garantisce la completezza o attualità
- Non è responsabile per errori, omissioni o imprecisioni nei contenuti
- I contenuti hanno valore informativo e non costituiscono offerta contrattuale vincolante

**Link Esterni**
- Il Sito può contenere link a siti di terze parti
- Non siamo responsabili per i contenuti o le pratiche di siti esterni
- L'inclusione di link non implica approvazione o raccomandazione

**Danni**
Salvo nei casi di dolo o colpa grave, ELLEGI non è responsabile per:
- Danni diretti o indiretti derivanti dall'uso del Sito
- Perdita di dati, profitti o opportunità commerciali
- Malfunzionamenti o incompatibilità tecniche`
                },
                {
                    title: "7. Comunicazioni Commerciali",
                    content: `Previo tuo consenso esplicito, ELLEGI può inviarti comunicazioni commerciali relative a:

- Newsletter con aggiornamenti su prodotti e servizi
- Offerte promozionali e sconti
- Inviti a eventi, fiere e manifestazioni
- Contenuti informativi sul settore illuminotecnico

Puoi revocare il consenso in qualsiasi momento:
- Cliccando sul link "unsubscribe" presente nelle email
- Inviando richiesta a: comm@lg-mi.it
- Contattando il numero: +39 02 2895741

La revoca è gratuita e ha effetto immediato.`
                },
                {
                    title: "8. Privacy e Protezione dei Dati",
                    content: `Il trattamento dei dati personali è regolato dalla nostra Privacy Policy, che costituisce parte integrante dei presenti Termini e Condizioni.

Ti invitiamo a consultare la Privacy Policy per informazioni dettagliate su:
- Tipologie di dati raccolti
- Finalità e base giuridica del trattamento
- Destinatari dei dati
- Diritti dell'interessato secondo il GDPR
- Misure di sicurezza adottate

Per esercitare i tuoi diritti o per informazioni, contatta: comm@lg-mi.it`
                },
                {
                    title: "9. Legge Applicabile e Foro Competente",
                    content: `I presenti Termini e Condizioni sono regolati dalla legge italiana.

**Foro competente:**
Per qualsiasi controversia relativa all'interpretazione, esecuzione o validità dei presenti Termini, sarà competente in via esclusiva il Foro di Milano, salvo diversa disposizione inderogabile di legge.

**Risoluzione alternativa delle controversie:**
Prima di adire le vie legali, le parti si impegnano a tentare una composizione amichevole della controversia mediante negoziazione diretta.`
                },
                {
                    title: "10. Modifiche ai Termini",
                    content: `ELLEGI si riserva il diritto di modificare i presenti Termini e Condizioni in qualsiasi momento.

**Notifica delle modifiche:**
- Le modifiche sostanziali saranno comunicate tramite avviso sul Sito
- La data di ultimo aggiornamento sarà sempre indicata in alto
- Potremmo inviarti una notifica via email per modifiche significative

**Effetti delle modifiche:**
- L'uso continuato del Sito dopo le modifiche costituisce accettazione dei nuovi termini
- Se non accetti le modifiche, devi cessare l'utilizzo del Sito

Ti invitiamo a consultare periodicamente questa pagina per rimanere informato.`
                },
                {
                    title: "11. Disposizioni Finali",
                    content: `**Invalidità Parziale**
Se una o più disposizioni dei presenti Termini dovessero risultare invalide o inapplicabili, le restanti disposizioni rimarranno pienamente valide ed efficaci.

**Rinuncia**
L'eventuale mancato esercizio da parte di ELLEGI di un diritto previsto dai presenti Termini non costituisce rinuncia a tale diritto.

**Intero Accordo**
I presenti Termini, unitamente alla Privacy Policy e alla Cookie Policy, costituiscono l'intero accordo tra l'utente e ELLEGI relativamente all'uso del Sito.

**Lingua**
In caso di discrepanza tra la versione italiana e inglese, prevarrà la versione italiana.`
                },
                {
                    title: "12. Contatti",
                    content: `Per qualsiasi domanda, chiarimento o richiesta relativi ai presenti Termini e Condizioni, puoi contattarci:

**ELLEGI S.r.l.**
Viale Vittorio Veneto, 6
20124 Milano (MI), Italia

**Email:** comm@lg-mi.it
**Telefono:** +39 02 2895741
**Sito web:** www.lg-mi.it

**Orari ufficio:**
Lunedì - Venerdì: 9:00 - 13:00 / 14:00 - 18:00

Ci impegniamo a rispondere entro 48 ore lavorative.`
                }
            ]
        },
        en: {
            title: "Terms and Conditions of Service",
            lastUpdated: "Last updated: February 16, 2026",
            sections: [
                {
                    title: "1. General Information",
                    content: `These Terms and Conditions of Service govern the use of the website www.lg-mi.it (hereinafter "Site") and the services offered by ELLEGI S.r.l. (hereinafter "ELLEGI" or "Company").

**ELLEGI S.r.l.**
Registered office: Viale Vittorio Veneto, 6 - 20124 Milan (MI), Italy
VAT: 08437620159
Email: comm@lg-mi.it
Tel: +39 02 2895741

Use of the Site implies full and unconditional acceptance of these Terms and Conditions.`
                },
                {
                    title: "2. Acceptance of Terms",
                    content: `By accessing and using this Site, the user declares to:

- Have read, understood and fully accepted these Terms and Conditions
- Have the legal capacity to accept these terms
- Be of legal age according to Italian law (18 years old)
- Use the Site in compliance with applicable laws

If you do not accept these terms, please do not use the Site.`
                },
                {
                    title: "3. Services Offered",
                    content: `ELLEGI specializes in providing professional lighting solutions for the following sectors:

- **Offices:** Lighting for work environments
- **Retail:** Solutions for shops and commercial spaces
- **Hospitality:** Lighting for hotels, restaurants and accommodation facilities
- **Industry:** Solutions for industrial and production environments
- **Consulting:** Lighting design and specialist consultancy

Services may include:
- Consulting and design
- Supply of lighting fixtures
- Installation and maintenance
- After-sales technical support

Specific commercial conditions will be defined in separate contracts or quotes.`
                },
                {
                    title: "4. Intellectual Property",
                    content: `All content on the Site, including but not limited to:

- Texts, images, photographs, videos
- Logos, trademarks, distinctive signs
- Graphics, layout, design
- Software, source code
- Technical documents, catalogs, product sheets

are the exclusive property of ELLEGI S.r.l. or their respective owners and are protected by Italian and international copyright and industrial property laws.

**It is prohibited to:**
- Reproduce, copy, modify or distribute content without written authorization
- Use content for unauthorized commercial purposes
- Remove or alter copyright notices, trademarks or other rights
- Reverse engineer or decompile software

It is permitted to:
- View and download content for personal and non-commercial use
- Share links to the Site
- Quote brief excerpts with proper attribution`
                },
                {
                    title: "5. User Obligations",
                    content: `The user undertakes to:

**Lawful Use**
- Use the Site in compliance with law and good practice
- Not violate third party or Company rights
- Not disseminate illegal, defamatory, obscene or threatening content

**Security**
- Not attempt to access restricted areas of the Site
- Not carry out cyber attacks, hacking or other harmful activities
- Not send viruses, malware or harmful code
- Not overload servers or interfere with Site operation

**Communications**
- Provide truthful and accurate information in contact forms
- Not use the Site for spam or unsolicited communications
- Respect the privacy of third parties

Violation of these obligations may result in suspension of Site access and legal action.`
                },
                {
                    title: "6. Limitation of Liability",
                    content: `To the extent permitted by law, ELLEGI:

**Site Availability**
- Does not guarantee that the Site will always be available, error-free or uninterrupted
- Reserves the right to modify, suspend or discontinue the Site at any time
- Is not responsible for outages caused by external factors (internet connections, force majeure)

**Content**
- Strives to provide accurate information, but does not guarantee completeness or timeliness
- Is not responsible for errors, omissions or inaccuracies in content
- Content is informative and does not constitute a binding contractual offer

**External Links**
- The Site may contain links to third party sites
- We are not responsible for the content or practices of external sites
- Inclusion of links does not imply approval or recommendation

**Damages**
Except in cases of intent or gross negligence, ELLEGI is not liable for:
- Direct or indirect damages arising from use of the Site
- Loss of data, profits or business opportunities
- Malfunctions or technical incompatibilities`
                },
                {
                    title: "7. Commercial Communications",
                    content: `With your explicit consent, ELLEGI may send you commercial communications regarding:

- Newsletters with updates on products and services
- Promotional offers and discounts
- Invitations to events, fairs and exhibitions
- Informative content on the lighting sector

You can withdraw consent at any time:
- By clicking the "unsubscribe" link in emails
- By sending a request to: comm@lg-mi.it
- By calling: +39 02 2895741

Withdrawal is free and takes immediate effect.`
                },
                {
                    title: "8. Privacy and Data Protection",
                    content: `The processing of personal data is governed by our Privacy Policy, which forms an integral part of these Terms and Conditions.

We invite you to consult the Privacy Policy for detailed information on:
- Types of data collected
- Purpose and legal basis of processing
- Data recipients
- Data subject rights under GDPR
- Security measures adopted

To exercise your rights or for information, contact: comm@lg-mi.it`
                },
                {
                    title: "9. Applicable Law and Jurisdiction",
                    content: `These Terms and Conditions are governed by Italian law.

**Competent court:**
For any dispute relating to the interpretation, execution or validity of these Terms, the Court of Milan shall have exclusive jurisdiction, except where otherwise provided by mandatory law.

**Alternative dispute resolution:**
Before resorting to legal action, the parties undertake to attempt an amicable settlement of the dispute through direct negotiation.`
                },
                {
                    title: "10. Changes to Terms",
                    content: `ELLEGI reserves the right to modify these Terms and Conditions at any time.

**Notification of changes:**
- Substantial changes will be communicated via notice on the Site
- The date of last update will always be indicated at the top
- We may send you an email notification for significant changes

**Effects of changes:**
- Continued use of the Site after changes constitutes acceptance of the new terms
- If you do not accept the changes, you must cease using the Site

We invite you to periodically consult this page to stay informed.`
                },
                {
                    title: "11. Final Provisions",
                    content: `**Partial Invalidity**
If one or more provisions of these Terms should be invalid or unenforceable, the remaining provisions shall remain fully valid and effective.

**Waiver**
Any failure by ELLEGI to exercise a right under these Terms does not constitute a waiver of that right.

**Entire Agreement**
These Terms, together with the Privacy Policy and Cookie Policy, constitute the entire agreement between the user and ELLEGI regarding use of the Site.

**Language**
In case of discrepancy between the Italian and English version, the Italian version shall prevail.`
                },
                {
                    title: "12. Contact",
                    content: `For any questions, clarifications or requests regarding these Terms and Conditions, you can contact us:

**ELLEGI S.r.l.**
Viale Vittorio Veneto, 6
20124 Milan (MI), Italy

**Email:** comm@lg-mi.it
**Phone:** +39 02 2895741
**Website:** www.lg-mi.it

**Office hours:**
Monday - Friday: 9:00 AM - 1:00 PM / 2:00 PM - 6:00 PM

We are committed to responding within 48 business hours.`
                }
            ]
        }
    };

    const currentContent = language === 'it' ? content.it : content.en;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-[--bg-primary] overflow-y-auto"
        >
            {/* Header */}
            <div className="sticky top-0 z-10 bg-[--bg-primary]/95 backdrop-blur-sm border-b border-[--border-color]">
                <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
                    <button
                        onClick={onClose}
                        className="flex items-center gap-2 text-[--text-secondary] hover:text-[--accent] transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        <span>{language === 'it' ? 'Torna alla Home' : 'Back to Home'}</span>
                    </button>
                    <button
                        onClick={onClose}
                        className="w-10 h-10 rounded-full bg-[--accent]/20 flex items-center justify-center hover:bg-[--accent] transition-colors group"
                    >
                        <X className="w-5 h-5 text-[--accent] group-hover:text-black transition-colors" />
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-6 py-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-[--accent] mb-2">
                        {currentContent.title}
                    </h1>
                    <p className="text-sm text-[--text-secondary] mb-12">
                        {currentContent.lastUpdated}
                    </p>

                    <div className="space-y-8">
                        {currentContent.sections.map((section, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 * (index + 1) }}
                                className="bg-[--bg-secondary] p-6 rounded-lg border border-[--border-color]"
                            >
                                <h2 className="text-xl font-bold text-[--text-primary] mb-4">
                                    {section.title}
                                </h2>
                                <MarkdownRenderer content={section.content} />
                            </motion.div>
                        ))}
                    </div>

                    {/* Footer CTA */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.5 }}
                        className="mt-12 p-6 bg-[--accent]/10 border border-[--accent]/20 rounded-lg text-center"
                    >
                        <p className="text-[--text-primary] mb-4">
                            {language === 'it'
                                ? 'Hai domande sui Termini di Servizio?'
                                : 'Do you have questions about the Terms of Service?'}
                        </p>
                        <a
                            href="mailto:comm@lg-mi.it"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-[--accent] hover:bg-[--accent-hover] text-black font-semibold rounded-lg transition-colors"
                        >
                            {language === 'it' ? 'Contattaci' : 'Contact Us'}
                        </a>
                    </motion.div>
                </motion.div>
            </div>
        </motion.div>
    );
}
